import { AccordionBody, AccordionHeader, AccordionItem } from "../../Accordion";
import RadioCard from "../../RadioCard";
import ValidatedField from "../../form/ValidatedField";
import {
  RevisorsSectionProps,
  scrollToRefIfNotInView,
} from "../RevisorsErklaering";

export default function RevisorsHandling8(props: RevisorsSectionProps) {
  const { locked, isCompleteHelpers, formikProps, refs, texts } = props;
  const { revisors_handling_8 } = texts;
  const { values, errors, touched } = formikProps;
  return (
    <AccordionItem value="Handling8">
      <AccordionHeader
        sectionStarted={!!values.revisors_handling_8_question}
        sectionComplete={isCompleteHelpers.revisors_handling_8_complete}
        ref={refs.handling_8_ref}
        onClick={() => {
          scrollToRefIfNotInView(refs.handling_7_ref);
        }}
      >
        {revisors_handling_8.title}
      </AccordionHeader>
      <AccordionBody>
        <fieldset disabled={locked}>
          <legend className="h5 fw-normal mb-4 lh-base">
            {revisors_handling_8.description}
          </legend>
          <div className="vstack gap-3" role="group">
            <RadioCard
              name={revisors_handling_8.revisors_handling_8_question.id}
              id={
                revisors_handling_8.revisors_handling_8_question
                  .revisors_handling_8_question_alt_1.value
              }
              value={
                revisors_handling_8.revisors_handling_8_question
                  .revisors_handling_8_question_alt_1.value
              }
              text={
                revisors_handling_8.revisors_handling_8_question
                  .revisors_handling_8_question_alt_1.label
              }
            ></RadioCard>
            <RadioCard
              name={revisors_handling_8.revisors_handling_8_question.id}
              id={
                revisors_handling_8.revisors_handling_8_question
                  .revisors_handling_8_question_alt_2.value
              }
              value={
                revisors_handling_8.revisors_handling_8_question
                  .revisors_handling_8_question_alt_2.value
              }
              text={
                revisors_handling_8.revisors_handling_8_question
                  .revisors_handling_8_question_alt_2.label
              }
            >
              <label
                htmlFor={
                  revisors_handling_8.revisors_handling_8_alt_2_beskrivelse.id
                }
                className="mb-2"
              >
                {
                  revisors_handling_8.revisors_handling_8_alt_2_beskrivelse
                    .label
                }
              </label>
              <ValidatedField
                touched={touched.revisors_handling_8_alt_2_beskrivelse}
                error={errors.revisors_handling_8_alt_2_beskrivelse}
                autoComplete="off"
                as="textarea"
                id={
                  revisors_handling_8.revisors_handling_8_alt_2_beskrivelse.id
                }
                name={
                  revisors_handling_8.revisors_handling_8_alt_2_beskrivelse.id
                }
                placeholder="Beskrivelse"
                rows={2}
              />
            </RadioCard>
          </div>
        </fieldset>
      </AccordionBody>
    </AccordionItem>
  );
}
